import React from 'react'
import s from './styles/CareersTab.module.scss'
import useCareersTab from './hooks/useCareersTab'
import PersonalityHero from './components/PersonalityHero/PersonalityHero'
import SuperProfileCards from './components/SuperProfileCards/SuperProfileCards'
import InsightsSection from './components/InsightsSection/InsightsSection'
import ExpandingStrengths from './components/ExpandingStrengths/ExpandingStrengths'

const CareersTab = ({ studentId = null, isActive = false }) => {
	const {
		isLoading,
		error,
		isNotCompleted,
		personality,
		superProfile,
		superpowers,
		blindspots,
		campusVibe,
		expandingStrengths,
		hasTraitScores,
	} = useCareersTab(studentId, isActive)

	if (!studentId) {
		return <div className={s.state}>Student is not selected.</div>
	}

	if (error) {
		return <div className={s.stateError}>{error}</div>
	}

	if (!isLoading && isNotCompleted) {
		return (
			<div className={s.state}>
				This student hasn&apos;t completed the career quiz yet.
			</div>
		)
	}

	return (
		<div className={s.wrap}>
			<div className={s.top}>
				<PersonalityHero personality={personality} isLoading={isLoading} />
				<SuperProfileCards superProfile={superProfile} isLoading={isLoading} />
			</div>

			<InsightsSection
				superpowers={superpowers}
				blindspots={blindspots}
				campusVibe={campusVibe}
				hasTraitScores={hasTraitScores}
				isLoading={isLoading}
			/>

			<ExpandingStrengths
				rows={expandingStrengths}
				hasTraitScores={hasTraitScores}
				isLoading={isLoading}
			/>
		</div>
	)
}

export default CareersTab
